import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import '../assets/styles/Home.css'

const Home = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> BuddyTech Solutions – Innovative Web & Tech Services </title>
        <meta name="description" content="We build modern websites, apps, CRM & ERP for businesses. Expert in development, design, MIS, construction planning & consulting." />
        <meta name="keywords" content="web development, CRM, ERP, UI/UX, analytics, construction planning" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="BuddyTech Solutions – Innovative Web & Tech Services" />
        <meta property="og:description" content="We build modern websites, apps, CRM & ERP for businesses. Expert in development, design, MIS, construction planning & consulting." />
        <meta property="og:keywords" content="web development, CRM, ERP, UI/UX, analytics, construction planning" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="BuddyTech Solutions – Innovative Web & Tech Services" />
        <meta name="twitter:description" content="We build modern websites, apps, CRM & ERP for businesses. Expert in development, design, MIS, construction planning & consulting." />
        <meta name="twitter:keywords" content="web development, CRM, ERP, UI/UX, analytics, construction planning" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="home-page">

        {/* Hero Section */}
        <section className="hero-section text-center text-white d-flex align-items-center justify-content-center">
          <div className="container">
            <h1 className='permanent-marker-regular'>Welcome to Buddy Tech Solution</h1>
            <p className='caveat banner_content'>Your trusted freelance platform for developers, designers, Constructions, MIS experts, and more.</p>
            <Link to="/contact" className="btn btn-primary mt-3">Work With Us</Link>
          </div>
        </section>

        {/* About Section */}
        <section className="about-section py-5 bg-light">
          <div className="container">
            <h2 className="text-center mb-4">Who We Are</h2>
            <p className="text-center">
              Buddy Tech Solution is a modern freelancer hub. We empower talented professionals to work on real projects
              across industries—whether you're a developer, UI/UX designer, MIS executive, or creative artist.
            </p>
          </div>
        </section>

        {/* Services for Freelancer Types */}
        <section className="services-section py-5">
          <div className="container">
            <h2 className="text-center mb-5">Departments We Serve</h2>
            <div className="row text-center">
              <div className="col-md-3 mb-4">
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title">Developers</h5>
                    <p className="card-text">Frontend, Backend, and Full Stack experts in React, Node, and more.</p>
                    <Link to="/services/development" className="btn btn-outline-primary">Explore</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mb-4">
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title">Designers</h5>
                    <p className="card-text">UI/UX, graphics, branding and web design tailored to user needs.</p>
                    <Link to="/services/uiux" className="btn btn-outline-primary">Explore</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mb-4">
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title">MIS Executives</h5>
                    <p className="card-text">Data management, automation, and Excel/Power BI specialists.</p>
                    <Link to="/services/mis" className="btn btn-outline-primary">Explore</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mb-4">
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title">Custom Solutions</h5>
                    <p className="card-text">Have a unique project? We connect you to the right freelancer fast.</p>
                    <Link to="/contact" className="btn btn-outline-primary">Contact Us</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="why-section py-5 bg-dark text-white">
          <div className="container">
            <h2 className="text-center mb-4">Why Freelancers Love Us</h2>
            <ul className="list-unstyled text-center">
              <li>✔️ Flexible working hours</li>
              <li>✔️ Transparent payment system</li>
              <li>✔️ Regular high-quality projects</li>
              <li>✔️ Professional community support</li>
            </ul>
          </div>
        </section>

        {/* Final CTA */}
        <section className="cta-section py-5 text-center mb-4">
          <div className="container">
            <h2>Ready to Start Your Freelance Journey?</h2>
            <Link to="/contact" className="btn btn-success mt-3">Join Buddy Tech Solution</Link>
          </div>
        </section>

      </div>
    </>
  );
};

export default Home;
